import React from 'react';
import UpgradeCard from 'design-system/UpgradeCard';
import IconBlock from 'design-system/icons/IconBlock';
import { useAppSelector } from 'store/hooks';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { selectSmartRules } from '../selectors';
const UpgradeToUnlockSmartRules = () => {
    const smartRules = useAppSelector(selectSmartRules);
    const { isUnlocked, onPressUpgrade } = useShouldShowUpgrade({
        benefitId: 'smartRules',
    });
    if (isUnlocked || !smartRules.length)
        return null;
    return (<UpgradeCard title="Your smart rules are inactive" description="As soon as you upgrade your plan, your existing smart rules will automatically be reactivated." icon={<IconBlock />} onPressUpgrade={onPressUpgrade}/>);
};
export default UpgradeToUnlockSmartRules;
